/* this file is transformed by vux-loader */
/* eslint-disable */
import _classCallCheck from "/artifacts/APP/AppSwitchPowerActivityH5/AppSwitchPowerActivityH5_DEV_group1_dev_20200310201907/node_modules/@babel/runtime/helpers/builtin/es6/classCallCheck";
import _createClass from "/artifacts/APP/AppSwitchPowerActivityH5/AppSwitchPowerActivityH5_DEV_group1_dev_20200310201907/node_modules/@babel/runtime/helpers/builtin/es6/createClass";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";

function isExpired(expires) {
  var expirationDate = new Date(expires);
  var now = new Date();
  return now - expirationDate >= 0;
}

var VUE_APP_ENV = process.env.VUE_APP_ENV;

function getKey(key) {
  return "".concat(key, "_switch_h5_").concat(VUE_APP_ENV);
}

var _memory = {};

var Storage =
/*#__PURE__*/
function () {
  function Storage() {
    _classCallCheck(this, Storage);
  }

  _createClass(Storage, null, [{
    key: "getItem",
    value: function getItem(key) {
      var storageVal = localStorage.getItem(getKey(key));

      if (storageVal) {
        var data = JSON.parse(storageVal);

        if (data.expires && isExpired(data.expires)) {
          this.removeItem(key);
          return null;
        }

        return data.val;
      }

      return null;
    }
  }, {
    key: "setItem",
    value: function setItem(key, val, expirationDate) {
      if (val !== undefined) {
        var data = {
          expires: expirationDate && expirationDate.toGMTString(),
          val: val
        };
        return localStorage.setItem(getKey(key), JSON.stringify(data));
      }

      return undefined;
    }
  }, {
    key: "clear",
    value: function clear() {
      return localStorage.clear();
    }
  }, {
    key: "removeItem",
    value: function removeItem(key) {
      return localStorage.removeItem(getKey(key));
    }
  }, {
    key: "memory",
    get: function get() {
      return _memory;
    }
  }]);

  return Storage;
}();

export default Storage;